<template>
  <div class="col-md-1 d-none d-md-block align-self-center">
    <span v-if="!isConfirmed" class="badge badge-secondary">Unconfirmed</span>
    <span v-else-if="isActive" class="badge badge-success">Active</span>
    <span v-else class="badge badge-danger">Inactive</span>
  </div>
</template>

<script>
export default {
  name: "ActiveColumn",
  props: {
    isActive: Boolean,
    isConfirmed: {
      type: Boolean,
      default: true
    }
  }
};
</script>
